export const comments_5150490 = {"data":{"data":[],"links":{}}}